<template>
  <section class="flex flex-col sm:flex-row sm:items-center gap-4 rounded-2xl bg-gray-900/60 px-4 py-3">
    <div class="flex items-center gap-3 flex-1 min-w-0">
      <span class="relative flex-shrink-0">
        <span class="block rounded-full p-[2px]" :style="{ background: lan.twitch?.live ? '#E91916' : '#374151' }">
          <LanAvatar :src="lan.creator_picture_url" size="w-11 h-11 border-2 border-gray-900" />
        </span>
        <span
          v-if="lan.twitch?.live"
          class="absolute -bottom-1 left-1/2 -translate-x-1/2 text-[9px] font-bold text-white px-1 rounded"
          style="background:#E91916"
        >{{ $t('play.lan_party.live') }}</span>
      </span>
      <div class="min-w-0">
        <p class="text-sm font-semibold text-text-primary truncate">
          {{ $t('play.lan_party.lobby_title', { name: lan.creator_name }) }}
        </p>
        <p class="text-xs text-text-secondary flex items-center gap-x-2 truncate">
          <a
            v-if="twitchName && channelUrl"
            :href="channelUrl"
            target="_blank"
            rel="noopener"
            class="inline-flex items-center gap-1 hover:underline"
            style="color:#BF94FF"
          ><TwitchIcon class="w-3.5 h-3.5" />{{ twitchName }}</a>
          <TwitchViewers v-if="!over && lan.twitch?.live" style="color:#BF94FF" :count="lan.twitch.viewer_count" />
          <span>{{ over ? $t('play.lan_party.lobby_over') : $t('play.lan_party.lobby_live') }}</span>
        </p>
      </div>
    </div>
    <router-link
      v-if="over || manager"
      :to="{ name: manager ? 'LanControlRoomPage' : 'LanPartyPage', params: { slug: lan.creator } }"
      class="inline-flex items-center gap-2 px-4 py-2.5 rounded-lg text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300"
      :class="over ? 'bg-primary-600 text-white hover:bg-primary-500' : 'bg-gray-800 text-text-primary hover:bg-gray-700'"
    >
      <ArrowUturnLeftIcon class="w-4 h-4" aria-hidden="true" />
      {{ manager ? $t('play.lan_party.back_to_control_room') : $t('play.lan_party.back_to_lan') }}
    </router-link>
  </section>
</template>

<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';
import { ArrowUturnLeftIcon } from '@heroicons/vue/24/outline';
import LanAvatar from './LanAvatar.vue';
import TwitchIcon from './TwitchIcon.vue';
import TwitchViewers from './TwitchViewers.vue';
import { safeHttpUrl, twitchLogin } from '../../utils/lan_party';

const props = defineProps({
  lobby: { type: Object, required: true },
});

const store = useStore();
const lan = computed(() => props.lobby.lan_party);
const over = computed(() => ['completed', 'cancelled'].includes(props.lobby.status));
const channelUrl = computed(() => safeHttpUrl(lan.value.channel_url));
const twitchName = computed(() => twitchLogin(lan.value.channel_url));
// Managers of *this* creator only: on another creator's night they are viewers.
const manager = computed(() => {
  const mine = store.getters.matchmakingContext?.creator?.slug;
  return !!mine && mine === lan.value.creator;
});
</script>
